import { Skeleton } from "@mui/material";

export default function DivSkeleton() {
  return (
    <Skeleton animation="wave" style={{margin: '10px', alignSelf: 'center'}} variant="rounded" height={'25svh'} width={'80%'}/>
  )
}
